import { Controller } from "@hotwired/stimulus"
import { inlineTaskResult } from "../lib/inline_task_form_state.mjs"

// Saves the high-frequency task properties without leaving the detail
// workspace. The server remains authoritative and returns a freshly rendered
// workspace for both successful and invalid updates.
export default class extends Controller {
  static targets = ["submit", "status"]

  async submit(event) {
    event.preventDefault()
    if (this.saving) return

    this.saving = true
    this.element.setAttribute("aria-busy", "true")
    this.submitTarget.disabled = true
    this.statusTarget.textContent = "Saving…"

    try {
      const response = await fetch(this.element.action, {
        method: "PATCH",
        body: new FormData(this.element),
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-Slide-Panel": "true",
          "X-Inline-Task-Update": "true"
        }
      })

      const payload = await response.json()
      if (!response.ok && response.status !== 422) throw new Error(`HTTP ${response.status}`)
      this.renderResult(inlineTaskResult(response.ok, payload))
    } catch (_) {
      this.renderResult(inlineTaskResult(false))
    } finally {
      this.saving = false
      this.element.removeAttribute("aria-busy")
      this.submitTarget.disabled = false
    }
  }

  renderResult(result) {
    this.statusTarget.textContent = result.message
    this.statusTarget.classList.remove(
      "text-red-600", "dark:text-red-400",
      "text-green-700", "dark:text-green-300"
    )
    this.statusTarget.classList.add(...(
      result.tone === "success"
        ? ["text-green-700", "dark:text-green-300"]
        : ["text-red-600", "dark:text-red-400"]
    ))
  }
}
